import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as EligibilityRoute } from '~/core/routes/funding-requests/verifications/pipeline/[artifactDocumentId]/[creditFacilityId]/[reportingDate]/[fileVersion]/[verificationReportId]/eligibility/_index';
import { Route as VerificationDetailsRoute } from '~/core/routes/funding-requests/verifications/pipeline/[artifactDocumentId]/[creditFacilityId]/[reportingDate]/[fileVersion]/_index';
import { Route as HistoryRoute } from '~/core/routes/funding-requests/verifications/pipeline/history/_index';

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsFundingRequestsVerificationsPermissions;
};
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /funding-requests/verifications/*
  children: [
    {
      path:
        'pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion',
      element: <VerificationDetailsRoute />,
    },

    {
      path: 'pipeline/history',
      element: <HistoryRoute />,
    },
    {
      path:
        'pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion/:verificationReportId/eligibility',
      element: <EligibilityRoute />,
    },
    {
      path: '*',
      element: <Navigate to="/funding-requests" replace />,
    },
  ],
};
